
seedWebServices.service('PricesService', ['$resource', '$uibModal', '$http', '$cacheFactory',
function ($resource, $uibModal, $http, $cacheFactory) {

    var serviceCache = $cacheFactory('PricesService');
    var baseUrl = '../Api/PriceApi';

    this.resetCache = function () {
        serviceCache.removeAll();
    };

    this.getPricesCount = function () {
        return $http.get(baseUrl + '/GetPricesCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.getPrices = function (filterString, options, skipNumber, takeNumber, sort, materialID) {
        return $http.put(baseUrl + '/SearchPrices',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, materialID: materialID },
            { cache: serviceCache }
        );
    };

    this.getPricesColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(baseUrl + '/GetPricesColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };

    this.savePrice = function (price) {
        return $http.post(baseUrl + '/SavePrice', price, true);
    };

    this.savePrices = function (prices) {
        return $http.post(baseUrl + '/SavePrices', prices, true);
    };

    this.getPriceConfigs = function () {
        return $http.get(baseUrl + '/GetPriceConfigs', {
            params: {}
        });
    };

    this.getMBFAdditionals = function (filterString, options, skipNumber, takeNumber, sort, materialID) {
        console.log('getMBFAdditionals');
        return $http.put(baseUrl + '/GetMBFAdditionals',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, materialID: materialID },
            { cache: serviceCache }
        );
    };

    this.getMBFPrices = function (filterString, options, skipNumber, takeNumber, sort, materialID) {
        return $http.put(baseUrl + '/GetMBFPrices',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, materialID: materialID },
            { cache: serviceCache }
        );
    };

    this.readjustPrices = function (pricePerc) {
        return $http.put(baseUrl + '/ReadjustPrices', pricePerc, true);
    };

    this.getCurrencies = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(baseUrl + '/GetCurrencies',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };

    this.getCurrenciesCount = function () {
        return $http.get(baseUrl + '/GetCurrenciesCount', {
            cache: false
        });
    };

}]);
